import { render, staticRenderFns } from "./rejected.vue?vue&type=template&id=379bfb05&scoped=true&"
import script from "./rejected.vue?vue&type=script&lang=js&"
export * from "./rejected.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=379bfb05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bfb05",
  null
  
)

export default component.exports